import { OnInit, OnChanges, OnDestroy, SimpleChanges, ElementRef, Directive } from "@angular/core";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { KeyPressConstants } from '../vo/app-constants';
@Directive()
export class BaseView implements OnInit, OnChanges, OnDestroy{
    
    public currentIndex: number = -1;
    public showDropdown: boolean = false; 
    constructor() {}

	public ngOnInit() {}

	public ngOnChanges(changes: SimpleChanges) {}

	  public ngOnDestroy() {}

    public getShowDropdown(){
      return this.showDropdown;
    }

    public focusElement(dropdown, currentIndex){
      dropdown.forEach((element,index)=>{
        if(index === currentIndex){
          element.nativeElement.focus();
        }
      });
    }

    public navigateDropdown(event, fromBtn, showDropdown, dropdownBtn, dropdown, dropdownArray, sIndex ){
      if(event.key === KeyPressConstants.ARROWDOWN || event.key === KeyPressConstants.ARROWUP){
          event.preventDefault();
        }
      if(!fromBtn){
        if(event.key === KeyPressConstants.ESCAPE){
          showDropdown = false;
          dropdownBtn.nativeElement.focus();
        }
        else if(event.key === KeyPressConstants.ARROWUP){
          this.currentIndex  = (this.currentIndex > 0) ? this.currentIndex-1 : 0;
          this.focusElement(dropdown, this.currentIndex);
        }
        else if(event.key === KeyPressConstants.ARROWDOWN){
          this.currentIndex = (this.currentIndex < dropdownArray.length-1) ? this.currentIndex+1 : this.currentIndex;
          this.focusElement(dropdown, this.currentIndex);
        }
        else if(event.key === KeyPressConstants.TAB && !event.shiftKey){
          if(this.currentIndex < dropdownArray.length-1){
            this.currentIndex += 1;
          }
          else{
            showDropdown = false;
            dropdownBtn.nativeElement.focus();
          }
        }
        else if(event.key === KeyPressConstants.TAB && event.shiftKey){
          if(this.currentIndex > 0){
            this.currentIndex -= 1;
          }
          else{
            showDropdown = false;
          }
        }
      }
      else{
        if(event.key === KeyPressConstants.ESCAPE){
          showDropdown = false;
        }
        if(showDropdown === false && (event.key === KeyPressConstants.ARROWUP || event.key === KeyPressConstants.ARROWDOWN)){
          showDropdown = true;
        }
        if(sIndex != null){
          if(showDropdown === true && (event.key === KeyPressConstants.ENTER || event.key === KeyPressConstants.ARROWUP || event.key === KeyPressConstants.ARROWDOWN || event.key === KeyPressConstants.TAB)){
            if(event.key != KeyPressConstants.TAB){
              this.currentIndex = sIndex;
              this.focusElement(dropdown, this.currentIndex);
            }
            else{
              this.currentIndex = sIndex-1;
              this.focusElement(dropdown, this.currentIndex);
              this.currentIndex = sIndex;
            }
          }
        }
        else{
          if(showDropdown === true && (event.key === KeyPressConstants.ENTER || event.key === KeyPressConstants.ARROWUP || event.key === KeyPressConstants.ARROWDOWN || event.key === KeyPressConstants.TAB))
          if(event.key != KeyPressConstants.TAB && event.key != KeyPressConstants.ENTER){
            this.currentIndex = 0;
            this.focusElement(dropdown, this.currentIndex);
          }
          else{
            this.currentIndex = 0;
          }
        }
      }
      this.showDropdown = showDropdown;
    }
    public printDoc(docURL: string){
      let docFrame = document.createElement('iframe');
      docFrame.id = "DocumentPrint";
      docFrame.src = docURL;
      docFrame.hidden = true;
      document.body.appendChild(docFrame);
      docFrame.onload = function (){
        let removeChild = function (){document.body.removeChild(docFrame)};
        docFrame.contentWindow.onbeforeunload = removeChild;
        docFrame.contentWindow.onafterprint = removeChild;
        UtilityScripts.addScroll(docFrame.contentWindow.document);
        docFrame.contentWindow.focus();
        docFrame.contentWindow.print();
      }
    }
}
